import entrepreneurshipsOrganizer from '@/pages/organizer/entrepreneurships/entrepreneurshipsOrganizer.vue'
import showEntrepreneurshipOrganizer from '@/pages/organizer/entrepreneurships/show/showEntrepreneurshipOrganizer.vue'
import showConvocationFormOrganizer from '@/pages/organizer/entrepreneurships/show/showConvocationFormOrganizer.vue'
import showTeamOrganizer from '@/pages/organizer/entrepreneurships/show/showTeamOrganizer.vue'
import showWindowOrganizer from '@/pages/organizer/entrepreneurships/show/showWindowOrganizer.vue'
import showViewsOrganizer from '@/pages/organizer/entrepreneurships/show/showViewsOrganizer.vue'
import showLikesOrganizer from '@/pages/organizer/entrepreneurships/show/showLikesOrganizer.vue'

import standsOrganizer from '@/pages/organizer/stands/standsOrganizer.vue'
import showStandOrganizer from '@/pages/organizer/stands/showStandOrganizer.vue'
import editStandOrganizer from '@/pages/organizer/stands/editStandOrganizer.vue'

import entrepreneursOrganizer from '@/pages/organizer/entrepreneurs/entrepreneursOrganizer.vue'

const organizerRoutes = [
  {
    path: '/organizer/entrepreneurships',
    name: 'entrepreneurshipsOrganizer',
    component: entrepreneurshipsOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendimientos'
        }
      ]
    }
  },
  {
    path: '/organizer/entrepreneurships/:entrepreneurship_id/entrepreneurship',
    name: 'showEntrepreneurshipOrganizer',
    component: showEntrepreneurshipOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsOrganizer'}
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/organizer/entrepreneurships/:entrepreneurship_id/entrepreneurship/convocation-form',
    name: 'showConvocationFormOrganizer',
    component: showConvocationFormOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsOrganizer'}
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipOrganizer'}
        },
        {
          text: 'Formulario de convocatoria'
        }
      ]
    }
  },
  {
    path: '/organizer/entrepreneurships/:entrepreneurship_id/entrepreneurship/team',
    name: 'showTeamOrganizer',
    component: showTeamOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsOrganizer'}
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipOrganizer'}
        },
        {
          text: 'Equipo'
        }
      ]
    }
  },
  {
    path: '/organizer/entrepreneurships/:entrepreneurship_id/entrepreneurship/stand',
    name: 'showWindowOrganizer',
    component: showWindowOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsOrganizer'}
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipOrganizer'}
        },
        {
          text: 'Stand'
        }
      ]
    }
  },
  {
    path: '/organizer/entrepreneurships/:entrepreneurship_id/entrepreneurship/views',
    name: 'showViewsOrganizer',
    component: showViewsOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsOrganizer'}
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipOrganizer'}
        },
        {
          text: 'Visualizaciones'
        }
      ]
    }
  },
  {
    path: '/organizer/entrepreneurships/:entrepreneurship_id/entrepreneurship/likes',
    name: 'showLikesOrganizer',
    component: showLikesOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendimientos',
          to: { name: 'entrepreneurshipsOrganizer'}
        },
        {
          text: 'Ver',
          to: { name: 'showEntrepreneurshipOrganizer'}
        },
        {
          text: 'Visualizaciones'
        }
      ]
    }
  },
  
  {
    path: '/organizer/project-gallery',
    name: 'standsOrganizer',
    component: standsOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Galeria de Emprendimientos'
        }
      ]
    }
  },
  {
    path: '/organizer/project-gallery/:edition_id/:entrepreneurship_id',
    name: 'showStandOrganizer',
    component: showStandOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Galeria de Emprendimientos',
          to: { name: 'standsOrganizer'}
        },
        {
          text: 'Stand'
        }
      ]
    }
  },
  {
    path: '/organizer/project-gallery/:edition_id/:entrepreneurship_id/edit',
    name: 'editStandOrganizer',
    component: editStandOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Galeria de Emprendimientos',
          to: { name: 'standsOrganizer'}
        },
        {
          text: 'Stand',
          to: { name: 'showStandOrganizer'}
        },
        {
          text: 'EditarStand'
        }
      ]
    }
  },

  
  
  {
    path: '/organizer/entrepreneurs',
    name: 'entrepreneursOrganizer',
    component: entrepreneursOrganizer,
    meta: {
      auth: true,
      role: 'organizer',
      breadCrumb: [
        {
          text: 'Emprendedores'
        }
      ]
    }
  }
]

export default organizerRoutes